import { createSelector } from 'reselect';
export const selectObjBuilderState = state => state.navObjBuilderMenu;
export const selectObjBuilderMenuItems = createSelector(selectObjBuilderState, state => state.items);
export const selectHasObjBuilderMenuItems = createSelector(selectObjBuilderMenuItems, items => items.length > 0);